// extracted by mini-css-extract-plugin
export default {"nameProfile":"JEGtoTwa","nameText":"cWpr__lU","wrapperAvatar":"lxjki9eR","desktop":"desktop","outlined":"p8xjiuRI"};